import {Song} from '../../types';

class Queue {
  public queue: Song[];

  constructor(initialSongs: Song[] = []) {
    this.queue = [...initialSongs];
    this.removeFromQueue = this.removeFromQueue.bind(this);
    this.clearQueue = this.clearQueue.bind(this);
  }

  public clearQueue() {
    this.queue = [];
  }

  public addToQueue(song: Song) {
    this.queue = [...this.queue, song];
  }

  public setQueue(songs: Song[]) {
    this.queue = songs;
  }

  public removeFromQueue(id: Song["id"]) {
    this.queue = this.queue.filter((song) => song.id !== id);
  }
}

export default Queue;
